import { SET_LOCATEDDRIVERS } from '../actions';

const locateddrivers = (state = [], action) => {
  switch (action.type) {
	case SET_LOCATEDDRIVERS:
      return [...action.value];  
    default: return state;
  }
}

export default locateddrivers;
